define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var ProfileModel = /** @class */ (function () {
        function ProfileModel(data) {
            this.Id = ko.observable(0);
            this.Login = ko.observable();
            this.EMail = ko.observable();
            this.OldPassword = ko.observable();
            this.NewPassword = ko.observable();
            this.ConfirmPassword = ko.observable();
            this.FirstName = ko.observable();
            this.LastName = ko.observable();
            this.ExternalId = ko.observable(0);
            this.PhoneNumber = ko.observable();
            this.TwoFactorType = ko.observable();
            this.TwoFactorEnabled = ko.observable();
            this.TOTPSecretKey = ko.observable();
            this.ApiClientId = ko.observable();
            this.ApiKey = ko.observable();
            this.IsExternalUser = ko.observable(true);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, ProfileModel.Mapping, self);
            }
        }
        ProfileModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new ProfileModel(options.data);
            }
        };
        return ProfileModel;
    }());
    return ProfileModel;
});
//# sourceMappingURL=ProfileModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/ProfileModel.js
// module id = 288
// module chunks = 2